// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2ck9g","image":"App_image__1fbxc"};